<script setup lang="ts">
import { definePage } from "unplugin-vue-router/runtime";
import { useAbility } from "@casl/vue";
import CompanyAddEditForm from "@/components/models/company/forms/CompanyAddEditForm.vue";
import { computed } from "vue";
import { useRoute } from "vue-router";

definePage({
  meta: {
    title: "generic.action.addEntity",
    titleParams: { entity: "generic.entity.company" },
    checkPrivileges: () => {
      const { can } = useAbility();
      return can($permActions.CREATE, $permSubjects.PRACTICE__COMPANY);
    },
  },
});
const route = useRoute();

const formForWhatType = computed(() => route.query.type as "gp" | "orthodontist");
</script>

<template>
  <v-skeleton-loader>
    <CompanyAddEditForm
      :form-for-what-type="formForWhatType === 'orthodontist' ? 'ortho' : formForWhatType"
    />
  </v-skeleton-loader>
</template>

<style scoped></style>
